import { useEffect, useState } from 'react';
import { auctionGet } from '../../api/auction';
import { useAuth } from '../../context/AuthContext';
import { useSeason } from '../../context/SeasonContext';
import { isAdminLikeRole } from '../../utils/roles';

export function useAdminAccess() {
  const { user, loading } = useAuth();
  const { season } = useSeason();
  const staff = isAdminLikeRole(user?.role);
  const key = `${user?.user_id}:${season?.id}`;
  const [permission, setPermission] = useState(null);

  useEffect(() => {
    if (loading || !user || staff) return undefined;
    let live = true;
    auctionGet('/lots?limit=1')
      .then((data) => { if (live) setPermission({ key, allowed: data.can_manage === true }); })
      .catch(() => { if (live) setPermission({ key, allowed: false }); });
    return () => { live = false; };
  }, [key, loading, staff, user]);

  return {
    loading: loading || Boolean(user && !staff && permission?.key !== key),
    allowed: staff || (permission?.key === key && permission.allowed),
    auctionOnly: !staff,
  };
}
